import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

const cities = ["Hyderabad", "Bengaluru", "Mumbai", "Goa", "Delhi"];

export const Footer = () => (
  <footer data-testid="main-footer" className="py-14 bg-[#F5F5F7] border-t border-[#D2D2D7]/60">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div>
          <img src="/nyla-logo.png" alt="Nyla Air Water" loading="lazy" decoding="async" className="h-16 w-auto mb-4" />
          <p className="text-xs text-[#86868B] max-w-sm leading-relaxed">
            Born from air. Perfected by nature.
          </p>
        </div>
        <nav className="flex flex-wrap gap-7">
          {[
            { label: "Innovation", to: "/innovation" },
            { label: "Products", to: "/products" },
            { label: "Sustainability", to: "/sustainability" },
            { label: "Vision", to: "/vision" },
            { label: "Journal", to: "/journal" },
            { label: "Intelligence", to: "/water-intelligence" },
            { label: "Contact", to: "/contact" },
            { label: "Sustainability Policy", to: "/sustainability-policy" },
            { label: "Privacy Policy", to: "/privacy-policy" },
          ].map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="text-xs font-medium text-[#86868B] hover:text-[#1D1D1F] transition-colors duration-200"
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>

      <div className="mt-10 pt-8 border-t border-[#D2D2D7]/60 flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <p className="text-[10px] tracking-[0.25em] uppercase font-semibold text-[#86868B] mb-2">
            Now Serving
          </p>
          <p data-testid="footer-cities" className="text-xs text-[#1D1D1F] font-medium">
            {cities.join(" · ")}
          </p>
        </div>
        <p data-testid="footer-tagline" className="text-xs md:text-sm tracking-[0.2em] uppercase font-semibold text-[#2C3E35]">
          Think Nyla. Drink with Purpose.
        </p>
      </div>

      <div className="mt-8 pt-6 border-t border-[#D2D2D7]/60 flex flex-col sm:flex-row justify-between gap-3">
        <p className="text-xs text-[#86868B]">© {new Date().getFullYear()} Nyla Air Water. All rights reserved.</p>
        <div className="flex items-center gap-6">
          <p className="text-xs text-[#86868B]">Where Nature Meets Purity</p>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="flex items-center gap-1.5 text-xs font-medium text-[#86868B] hover:text-[#1D1D1F] transition-colors duration-200"
          >
            <Lock className="w-3 h-3" />
            Team Login
          </Link>
        </div>
      </div>
    </div>
  </footer>
);
